module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("If you purchase this book without a cover you should be aware that this book may have been stolen property and reported as “unsold and destroyed” to the publisher. In such case neither the author nor the publisher has received any payment for this “stripped book.”")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("This book is a work of fiction. Names, characters, places, and incidents are the product of the author's imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 2010 by Nicole Peeler"), _c('br'), _vm._v("\nExcerpt from "), _c('em', [_vm._v("Tempest's Legacy")]), _vm._v(" copyright © 2010 by Nicole Peeler"), _c('br'), _vm._v("\nAll rights reserved. Except as permitted under the U.S. Copyright Act of 1976, no part of this publication may be reproduced, distributed, or transmitted in any form or by any means, or stored in a database or retrieval system, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Orbit"), _c('br'), _vm._v("\nHachette Book Group"), _c('br'), _vm._v("\n237 Park Avenue, New York, NY 10017"), _c('br'), _vm._v("\nVisit our website at "), _c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.orbitbooks.net",
      "target": "_blank"
    }
  }, [_vm._v("www.orbitbooks.net")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Orbit is an imprint of Hachette Book Group. The Orbit name and logo are trademarks of Little, Brown Book Group Limited.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First edition: July 2010")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("eISBN: 978-0-316-07601-2")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "crtH"
  }, [_vm._v("ATTENTION CORPORATIONS AND ORGANIZATIONS:")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Most Hachette Book Group books are available at quantity discounts"), _c('br'), _vm._v("with bulk purchase for educational, business, or sales promotional use."), _c('br'), _vm._v("For information, please call or write:")]), _vm._v(" "), _c('p', {
    staticClass: "crt2"
  }, [_vm._v("Special Markets Department, Hachette Book Group"), _c('br'), _vm._v("237 Park Avenue, New York, NY 10017"), _c('br'), _vm._v("Telephone: 1-800-222-6747 Fax: 1-800-477-5925")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ede79b82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780316076012_epub_cop_r1.vue
// module id = 66
// module chunks = 0